import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const SB: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 18 19" {...props}>
      <path d="M16.5 17.1702H1.5V4.57015H16.5M13 0.970154V2.77015H5V0.970154H3V2.77015H2C0.89 2.77015 0 3.57115 0 4.57015V17.1702C0 17.6475 0.210714 18.1054 0.585786 18.4429C0.960859 18.7805 1.46957 18.9702 2 18.9702H16C16.5304 18.9702 17.0391 18.7805 17.4142 18.4429C17.7893 18.1054 18 17.6475 18 17.1702V4.57015C18 4.09276 17.7893 3.63493 17.4142 3.29736C17.0391 2.9598 16.5304 2.77015 16 2.77015H15V0.970154M15 14.4702C15 13.9179 14.5523 13.4702 14 13.4702H10C9.44772 13.4702 9 13.9179 9 14.4702C9 15.0224 9.44772 15.4702 10 15.4702H14C14.5523 15.4702 15 15.0224 15 14.4702Z" />
      <path d="M9 10.9702C9 10.4179 9.44772 9.97015 10 9.97015H14C14.5523 9.97015 15 10.4179 15 10.9702C15 11.5224 14.5523 11.9702 14 11.9702H10C9.44772 11.9702 9 11.5224 9 10.9702Z" />
      <path d="M9 7.47015C9 6.91787 9.44772 6.47015 10 6.47015H14C14.5523 6.47015 15 6.91787 15 7.47015C15 8.02244 14.5523 8.47015 14 8.47015H10C9.44772 8.47015 9 8.02244 9 7.47015Z" />
    </SvgIcon>
  );
};

export default SB;
